import React, { Component } from 'react';
import { NavigationActions } from 'react-navigation';
import { connect } from "react-redux";
import { getActionForPathAndParams, getURIForAction } from "../modules/navigation"

const isModifiedEvent = event =>
  !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);

const Linkable = Inner => {
  class LinkableWrapped extends Component {
    render() {
      return (
        <Inner href={this.getURL()} onClick={this.onClick} {...this.props} />
      );
    }
    getAction = () => {
      const { to, href } = this.props;
      if (typeof to === 'string') {
        return NavigationActions.navigate({ routeName: to });
      } else if (typeof to === 'object' && typeof to.type === 'string') {
        return to;
      } else if (typeof to === 'object' && typeof to.routeName === 'string') {
        return NavigationActions.navigate(to);
      } else if (href) {
        const match = href.match(/^\/(.*)/);
        if (match) {
          const pathParts = match[1].split('#');
          const path = pathParts[0];
          let params = {};
          if (pathParts.length) {
            params.hash = pathParts[1];
          }
          const action = getActionForPathAndParams(path, params);
          return action;
        }
        return null;
      }
    };
    onClick = e => {
      const action = this.getAction();
      if (!isModifiedEvent(e) && action) {
        this.props.dispatch(action);
        e.preventDefault();
      }
    };
    getURL() {
      const action = this.getAction();
      if (!action) return '#';
      return getURIForAction(action);
    }
  }
  return LinkableWrapped;
};

const Link = Linkable(({navigation, dispatch, ...rest}) => <a {...rest} />);

Link.Linkable = Linkable;

export default connect(({ navigation }) => ({ navigation }))(Link);



// WEBPACK FOOTER //
// ./src/components/Link.js